import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id 775EA566-CF0B-473E-B43E-59319FC83D38
 * name zip-disk
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/zip-disk.svg
 * tags
 */
export const ZipDiskIcon = createSvgIcon(<><path d="M7,3L3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5L17,3V5A1,1 0 0,1 16,6H10A1,1 0 0,1 9,5V3H7M8,10H16A1,1 0 0,1 17,11V19H7V11A1,1 0 0,1 8,10Z" /></>, 'ZipDiskIcon');
export default ZipDiskIcon